import "slick-carousel/slick/slick.min.js";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const defaultSlickOptions = {
	fade: false,
	autoplay: false,
	autoplaySpeed: 2000,
	dots: true,
	arrows: false,
	speed: 400,
	adaptiveHeight: false,
	pauseOnFocus: false,
	cssEase: "linear"
};

export default defaultSlickOptions;
